import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { Helper } from './lib/helpers';

@NgModule({
  imports: [CommonModule, NgxsReduxDevtoolsPluginModule.forRoot({ disabled: !Helper.isEnvironmentDev() })],
})
export class ProfilumLibraryModule {}
